<ul class="layout-menu" *ngIf="loginServices.isValid">
    <li app-menuitem *ngFor="let item of this.userMenuService.rutas(); let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>